export const arraySort = (arr = [], compareKey = '', { isAsc, isString, process }) =>
  arr.sort((elemA, elemB) => {
    const B = elemB?.[compareKey] || 0;
    const A = elemA?.[compareKey] || 0;
    if (isString) {
      return isAsc ? A.toLowerCase().localeCompare(B.toLowerCase()) : B.toLowerCase().localeCompare(A.toLowerCase());
    }
    if (process) {
      return process(A, B, isAsc);
    }
    return isAsc ? A - B : B - A;
  });

export const dateSort = (A, B, isAsc) => (!isAsc ? new Date(A) - new Date(B) : new Date(B) - new Date(A));

const { min, max } = Math;

const _min = (arr, prop) =>
  min.apply(
    Math,
    arr.map((e) => e?.[prop]),
  );

const _max = (arr, prop) =>
  max.apply(
    Math,
    arr.map((e) => e?.[prop]),
  );

export const findMinMax = (arr = [], prop, isMax = false) => (isMax ? _max(arr, prop) : _min(arr, prop));

export const getCandelInfo = (arr, prop) => {
  if (!arr.length) return [];
  const open = arr[0]?.[prop];
  const close = arr[arr.length - 1]?.[prop];
  const low = findMinMax(arr, prop);
  const high = findMinMax(arr, prop, true);
  return [open, high, low, close];
};
